import styled from 'styled-components/macro';
import { WxText } from '../..';
import { AddressType } from '../../../hooks/api/queries/useAccountAddress';

interface AddressDisplayProps {
  address?: AddressType;
  black?: boolean;
}

export const AddressDisplay = ({
  address,
  black = false,
}: AddressDisplayProps) => {
  if (!address) return null;

  return (
    <Wrapper>
      <>
        <WxText
          text={`${address.firstname} ${address.lastname}`}
          bold
          darkMode={!black}
        />
        <WxText text={address.address1} darkMode={!black} />
        {address.address2 && (
          <WxText text={address.address2} darkMode={!black} />
        )}
        <WxText
          text={`${address.zipcode} - ${address.city}`}
          darkMode={!black}
          uppercase
        />
        <WxText text={address.mobilePhone} darkMode={!black} />
      </>

      <WxText text={address.email} darkMode={!black} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
